import shopifyEmpireGenericDefaults from '../shopify-empire-generic/config.js';

export default {
  ...shopifyEmpireGenericDefaults,
  includes: ['shopify-empire-generic'],
  fitmentSearch: {
    ...shopifyEmpireGenericDefaults.fitmentSearch,
    isAutoRedirectDisabled: true,
  },
  Widgets: [
    ...shopifyEmpireGenericDefaults.Widgets.filter((w) => !['SearchVehicleWidget'].includes(w.name)),
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
    },
  ],
};
